import modal from './modal-bottom';

const footer = document.querySelector('.m-footer');
const btnNewsletter = footer?.querySelector('.btn-newsletter');

btnNewsletter?.addEventListener('click', (e) => {
  e.preventDefault();
  // the panel closes on a click outside it, and this link is outside: without this the
  // panel would shut instead of coming back to the newsletter (modules/modal-bottom.ts)
  e.stopPropagation();
  modal.showModal();
});

// Phones: the newsletter sign-up at the top of the footer (snippets/footer-newsletter.liquid)
// reloads the page like the bottom panel's does, and Shopify adds #contact_form, which opens
// that panel (modules/modal-bottom.ts). Note which form was used, and come back to this one.
const footerForm = document.querySelector<HTMLFormElement>('.m-footer__newsletter-form');
const FROM_FOOTER = 'paracia:newsletter-from-footer';

footerForm?.addEventListener('submit', () => {
  try {
    sessionStorage.setItem(FROM_FOOTER, '1');
  } catch {}
});

// read only: modules/modal-bottom.ts clears the note once the page has loaded
const cameFromFooterNewsletter = (() => {
  try {
    return sessionStorage.getItem(FROM_FOOTER) === '1';
  } catch {
    return false;
  }
})();

if (cameFromFooterNewsletter) {
  window.addEventListener('load', () => {
    document.getElementById('footer-newsletter')?.scrollIntoView({ block: 'center' });
  });
}
